import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LOOKUP from 'constants/lookup';
import { storeRulesCrumb } from 'utils/breadcrumbInfo';
import { getStoreRules, deleteStoreRules } from 'actions/EntityActions';
import { showError } from 'actions/CommonActions';
// Basic
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
import DialogHeader from 'screens/components/basic/DialogHeader';
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import Grid from 'screens/components/basic/Grid';
// Advanced
import DialogInput from 'screens/components/advanced/DialogInput';
import GenericTable from 'screens/components/advanced/GenericTable';

import WithRouter from 'custom/withRouter';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';


class storeRulesPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            storeRulesList: [],
            value: 'Active',
            status: 'Active',
            linkURL: '/ecommerce/storerules/add',
            openDeleteDialog: false,
            selectedStoreRuleId: null

        }
    }

    componentWillMount() {
        this.getStoreRules();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.storeRulesList !== null && newProps.storeRulesList !== undefined && newProps.storeRulesList !== this.props.storeRulesList) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    storeRulesList: newProps.storeRulesList.map(item => {
                        return {
                            Name: item.name,
                            Status: (item.status == 1 ? <p className="statusIconGreen m-0">Active</p> : <p className="statusIconRed m-0">Inactive</p>),
                            Buttons: (
                                <div>
                                    <Button
                                        type="IconEditButton"
                                        onTouchTap={() => this.editStoreRules(item.id)} />
                                </div>
                            ),
                            Delete: (
                                <div>
                                    <div>
                                        <Button
                                            mini={true}
                                            type="IconDeleteButton"
                                            className="glyphicon glyphicon-remove-circle"
                                            onTouchTap={() => this.deleteStoreRules(item.id, item.status)} />
                                    </div>
                                </div>
                            )
                        }
                    })
                }
            });
        }
    }


    getStoreRules() {
        this.props.getStoreRules({
            branchId: this.props.branchId
        });
    }

    editStoreRules(id) {
        this.props.navigate(`/ecommerce/storerules/edit/${id}`);
    }

    deleteStoreRules = (id, status) => {
        if (status == 2) {
            this.openDeleteDialog(id)
        } else {
            this.props.showError("Active Store Rules cannot be deleted. To delete a Store Rule please ensure it is Inactive")
        }
    }

    openDeleteDialog = (id) => {
        this.setState({ openDeleteDialog: true, selectedStoreRuleId: id })
    }

    closeDeleteDialog = () => {
        this.setState({ openDeleteDialog: false });
    };

    confirmDeleteStoreRules = (branchId, id) => {
        this.props.deleteStoreRules({ branchId, id });
        this.closeDeleteDialog();
    };

    render() {
        let linkAdd = this.state.linkURL;

        return (
            <Grid headerContent={storeRulesCrumb}>
                <PageHeaderWithButton title={LOOKUP.ecommerce.storeRules.storeRuleslList.title}>
                    <Button
                        type="AddButton"
                        mini
                        className="bg-light-green"
                        label="ADD NEW RULE"
                        onTouchTap={() => this.props.navigate(linkAdd)}
                    />
                </PageHeaderWithButton>
                <div className="list-table-last list-no-p">
                    <CardSimple className="pa-1">
                        <GenericTable
                            className="table_center tableHeaderwhiteColorFont"
                            tableBodyClassName="productgroup-table"
                            multiSelectable={false}
                            enableSelectAll={false}
                            selectable={false}
                            stripedRows={true}
                            columns={LOOKUP.ecommerce.storeRulesColumns}
                            rows={this.state.storeRulesList} />
                    </CardSimple>
                </div>
                <DialogInput
                    title={
                        <DialogHeaderWithClose
                            text="CONFIRM DELETE"
                            classicClass="posDialogClassic"
                            handleClose={() => this.closeDeleteDialog()}
                        />
                    }
                    modal={true}
                    open={this.state.openDeleteDialog}
                    autoScrollBodyContent={true}
                    style={{ zIndex: "950" }}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="CancelButton"
                            label="Cancel"
                            primary={true}
                            className="btn-space-20"
                            onTouchTap={() => this.closeDeleteDialog()}
                        />,
                        <Button
                            key={2}
                            name="ConfirmDelete"
                            label="Delete"
                            primary={true}
                            onTouchTap={() => this.confirmDeleteStoreRules(this.props.branchId, this.state.selectedStoreRuleId)}
                        />
                    ]}
                    contentStyle={{ width: "65%" }}
                >
                    <p className="purpleText">
                        Are you sure you wish to delete this store Rule?
                    </p>
                </DialogInput>
            </Grid>
        );
    }
}
function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        storeRulesList: state.entity.storeRulesList
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getStoreRules: model => dispatch(getStoreRules(model)),
        showError: (message) => dispatch(showError(message)),
        deleteStoreRules: (model) => dispatch(deleteStoreRules(model))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(storeRulesPage));
